<script setup lang="ts">
import ClipListItem from "./ClipListItem.vue";

const props = defineProps(['clips','title', 'listType']);
const emit = defineEmits(['update-clips']);


</script>

<template>
  <div class="bg-surface-0 dark:bg-surface-900 shadow rounded-border p-3">
    <div class="flex justify-between items-center mb-3">
      <span class="flex justify-center">
      <span class="text-base text-surface-900 dark:text-surface-0 font-medium mr-2">{{props.title}}</span>
        <span > <Badge :value="clips.length"></Badge> </span>
      </span>
    </div>
    <div class="max-h-40 overflow-y-auto">
      <ul v-for="(clip, index) in clips" :key="clip.clip_number" class="list-none p-0 m-0">
        <ClipListItem 
          :index="index" 
          :clip-number="clip.clip_number" 
          :list-type="props.listType" 
          :removal-time="clip.removal_time" 
          :event-id="clip.event_id" 
          :fuel-level="clip.current_fuel_level || clip.fuel_level || clip.removal_fuel_level"
          @update-clips="$emit('update-clips')"
        />
      </ul>
    </div>
  </div>
</template>
